import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed, ref, watch } from 'vue';

interface IBreadcrumbJsonLD {
    '@type': string;
    'position': number;
    'name': string;
    'item': string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadcrumbList',
  setup(__props) {

const breadcrumb = computed<SitePath[]>(() => store.getters['app/breadcrumb']);

const seoJsonLDList = ref<IBreadcrumbJsonLD[]>([]);
const jsonLD = computed<string>(() => JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: seoJsonLDList.value
}));

watch(breadcrumb, onBreadcrumbChanged);
function onBreadcrumbChanged() {
    clearJsonLDBreadcrumbItems();
    createJsonLDBreadcrumbItems();
}

createJsonLDBreadcrumbItems();

function createJsonLDBreadcrumbItems() {
    if (breadcrumb.value) {
        breadcrumb.value.forEach((item, index) => {
            const obj: IBreadcrumbJsonLD = {
                '@type': 'ListItem',
                position: index + 1,
                name: item.displayName,
                item: item.absoluteUrl
            };
            seoJsonLDList.value.push(obj);
        });
    }
}

function clearJsonLDBreadcrumbItems() {
    while (seoJsonLDList.value.length > 0) {
        seoJsonLDList.value.pop();
    }
}


return { __sfc: true,breadcrumb, seoJsonLDList, jsonLD, onBreadcrumbChanged, createJsonLDBreadcrumbItems, clearJsonLDBreadcrumbItems }
}

})